<template functional>
  <router-link :to="props.link" class="list-result-style">
    <div
      class="list-result-style__tile-img"
      :style="`background: linear-gradient(${props.gradient}`"
    >
      <img
        :src="props.tileImg"
        onerror="this.style.display='none'"
        alt="Course background"
      />
    </div>
    <div class="list-result-style__title">
      <span>{{ props.course.name }}</span>
      <div
        v-if="props.course.has_sample_content && props.isFreeTrialUser"
        class="list-result-style__snipe"
      >
        Included
      </div>
      <div
        v-if="props.course.status === 'coming soon'"
        class="list-result-style__snipe"
      >
        Coming Soon
      </div>
    </div>
    <div class="list-result-style__duration">{{ props.duration }}</div>
    <div class="list-result-style__difficulty">
      <component
        :is="injections.components.Difficulty"
        :difficulty="props.difficulty || null"
      ></component>
    </div>
  </router-link>
</template>

<script>
import Difficulty from '@/components/properties/Difficulty.vue'

export default {
  name: 'ListResult',
  inject: {
    components: {
      type: Object,
      default() {
        return {
          Difficulty,
        }
      },
    },
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    course: {
      type: Object,
      required: false,
    },
    gradient: {
      type: String,
      required: true,
    },
    tileImg: {
      type: String,
      required: false,
    },
    duration: {
      type: String,
      required: true,
    },
    link: {
      type: Object,
      required: true,
    },
    difficulty: {
      type: String,
      required: false,
    },
    isFreeTrialUser: {
      type: Boolean,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.list-result-style {
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 15px 0;
  @include mobile {
    flex-wrap: nowrap;
  }
  &:hover {
    opacity: 0.7;
  }
  &__tile-img {
    width: 80px;
    height: 50px;
    & img {
      width: 80px;
      height: 50px;
    }
  }
  &__title {
    width: 45%;
    color: var(--white);
    font-size: 1rem;
    margin: 0 auto 0 20px;
    display: flex;
    align-content: center;
  }
  &__duration {
    width: 15%;
    color: var(--white);
  }
  &__difficulty {
    width: 15%;
    margin: 0 0 0 10px;
    @include mobile {
      margin: 0 0 0 auto;
    }
  }
  &__snipe {
    background: var(--black);
    color: var(--white);
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 700;
    padding: 7px 10px;
    margin: 0 10px;
  }
}
</style>
